import type { Deck } from '../../types';
import Cover from './slides/01-cover';
import TheProblem from './slides/02-the-problem';
import TheSolution from './slides/03-the-solution';
import TheProduct from './slides/04-the-product';
import TheCustomerWin from './slides/05-the-customer-win';
import TheCustomer from './slides/06-the-customer';
import WhyNow from './slides/07-why-now';
import CompetitiveLandscape from './slides/08-competitive-landscape';
import MoatTechEdge from './slides/09-moat-tech-edge';
import Validation from './slides/10-validation';
import FoundersWhyUs from './slides/11-founders-why-us';
import ASOMarket from './slides/12-aso-market';
import TheWiderPlay from './slides/13-the-wider-play';
import BusinessModelUnitEconomics from './slides/14-business-model-unit-economics';
import Roadmap from './slides/15-roadmap';
import ShapeAndUseOfFunds from './slides/16-shape-and-use-of-funds';
import CommonQuestions from './slides/A-common-questions';
import PlatformDepth from './slides/B-platform-depth';
import PlatformBreadth from './slides/C-platform-breadth';
import CapitalEfficiency from './slides/D-capital-efficiency';
import Sources from './slides/E-sources';
import ExpansionPath from './slides/F-expansion-path';
import EVTarget from './slides/G-ev-target';
import PlatformNative from './slides/H-platform-native';
import UnitCostModel from './slides/I-unit-cost-model';

export const seriesSeedPrimerV2: Deck = {
  slug: 'series-seed-primer-v2',
  title: 'Apptonomy — Pre-Seed Primer',
  slides: [
    {
      id: 'cover',
      title: 'Cover',
      Component: Cover,
      sectionBefore: 'Intro',
      stoplight: 'amber',
    },
    {
      id: 'the-problem',
      title: 'The Problem',
      Component: TheProblem,
      sectionBefore: 'Product',
      stoplight: 'amber',
    },
    {
      id: 'the-solution',
      title: 'The Solution',
      Component: TheSolution,
      stoplight: 'amber',
    },
    {
      id: 'the-product',
      title: 'The Platform',
      Component: TheProduct,
      stoplight: 'amber',
    },
    {
      id: 'the-customer-win',
      title: "Customer's Win",
      Component: TheCustomerWin,
      stoplight: 'amber',
    },
    {
      id: 'the-customer',
      title: 'The Customer',
      Component: TheCustomer,
      sectionBefore: 'Customer & Market',
      stoplight: 'amber',
    },
    { id: 'why-now', title: 'Why Now', Component: WhyNow, stoplight: 'amber' },
    {
      id: 'competitive-landscape',
      title: 'Competitive Landscape',
      Component: CompetitiveLandscape,
      stoplight: 'amber',
    },
    {
      id: 'moat-tech-edge',
      title: 'Moat / Tech Edge',
      Component: MoatTechEdge,
      stoplight: 'red',
    },
    {
      id: 'validation',
      title: 'Validation',
      Component: Validation,
      stoplight: 'red',
    },
    {
      id: 'founders-why-us',
      title: 'Why Us',
      Component: FoundersWhyUs,
      sectionBefore: 'Business',
      stoplight: 'amber',
    },
    {
      id: 'aso-market',
      title: 'The ASO Market',
      Component: ASOMarket,
      stoplight: 'amber',
    },
    {
      id: 'the-wider-play',
      title: 'The Wider Play',
      Component: TheWiderPlay,
      stoplight: 'amber',
    },
    {
      id: 'business-model-unit-economics',
      title: 'Economics',
      Component: BusinessModelUnitEconomics,
      stoplight: 'red',
    },
    { id: 'roadmap', title: 'Roadmap', Component: Roadmap, stoplight: 'red' },
    {
      id: 'shape-and-use-of-funds',
      title: 'Capitalization',
      Component: ShapeAndUseOfFunds,
      stoplight: 'red',
    },
    {
      id: 'common-questions',
      title: 'Common Questions',
      Component: CommonQuestions,
      sectionBefore: 'Appendices',
      stoplight: 'red',
    },
    {
      id: 'platform-depth',
      title: 'Platform Depth',
      Component: PlatformDepth,
      stoplight: 'red',
    },
    {
      id: 'platform-breadth',
      title: 'Platform Breadth',
      Component: PlatformBreadth,
      stoplight: 'red',
    },
    {
      id: 'capital-efficiency',
      title: 'Capital Efficiency',
      Component: CapitalEfficiency,
      stoplight: 'red',
    },
    { id: 'sources', title: 'Sources', Component: Sources, stoplight: 'red' },
    {
      id: 'expansion-path',
      title: 'Expansion Path',
      Component: ExpansionPath,
      stoplight: 'red',
    },
    {
      id: 'ev-target',
      title: 'EV Target',
      Component: EVTarget,
      stoplight: 'red',
    },
    {
      id: 'platform-native',
      title: 'Platform-Native Defense',
      Component: PlatformNative,
      stoplight: 'red',
    },
    {
      id: 'unit-cost-model',
      title: 'Unit-Cost Model',
      Component: UnitCostModel,
      stoplight: 'red',
    },
  ],
};
